module.exports = __webpack_public_path__ + "img/search.da9890a1.png";